import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconThx24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="THX">
            <path
                d="M24 7H5V16H3V7.00001L0 7V5H24V7Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M7 16V8H9V11H12V8H14V16H12V13H9V16H7Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M0 19V17H24V19H0Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M14.75 16H17.25L19 13.6667L20.75 16H23.25L20.25 12L23.25 8H20.75L19 10.3333L17.25 8H14.75L17.75 12L14.75 16Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconTHX48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="THX">
            <path
                d="M8.91176 16H2V14H46V16H11V30H8.91176V16Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M2 34H10.6788H46V32H2V34Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M27 18V30H25V25H18V30H16V18H18V23H25V18H27Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M41.1154 30L37.4615 25.44L33.8462 30H31L36 23.88L31.2692 18H34.0962L37.5385 22.2686L40.9423 18H43.6538L38.9423 23.7943L44 30H41.1154Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
